import checkReadMoreStyles from "./checkReadMore.module.css";

const checkReadMore = checkReadMoreStyles.checkReadMore; //mobile and desktop
const checklistReadMore = checkReadMoreStyles.checklistReadMore; //desktop

const checklistReadMoreData = [
  {
    id: 1,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "get help with troubleshooting difficult cases and backlog with on-going office support and training",
  },

  {
    id: 2,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "coordinators receive access to access boot camp advisors monday-friday 8:00 pm to 5:00 pm central",
  },

  {
    id: 3,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "office staff receive education on documentation and processing",
  },

  {
    id: 4,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: (
      <>
        <div>
          book a room and sharpen your skill set with priceless medical
          educational conferences. offered to both your office staff and
          coordinators
        </div>
        <br />
        <div>
          for coordinators who sign up get 50% off lodging
          <br />
          for office staff who sign up get 10% off lodging
        </div>
      </>
    ),
  },
  {
    id: 5,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "receive monthly check ins with a 12 week follow up",
  },
  {
    id: 6,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "receive one on one training for access to buy and bill specialists",
  },
  {
    id: 7,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "receive training on the process of patient leave behinds",
  },
  {
    id: 8,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "HIPAA compliant",
  },
  {
    id: 9,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "ehr knowledge: EMA, e-clinicals, nextgen, epic",
  },
  {
    id: 10,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "CoverMyMeds",
  },
  {
    id: 11,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "increase fill times",
  },
  {
    id: 12,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "copay card enrollments",
  },
  {
    id: 13,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "hub service enrollments",
  },
  {
    id: 14,
    divClassName: checklistReadMore,
    imgClassName: checkReadMore,
    span: "live excel spreadsheet tracking",
  },
];

export default checklistReadMoreData;
